import { useState } from "react";

interface UseSortingDropdownParams {
  defaultSortBy?: string;
}

interface UseSortingDropdownReturn {
  sortBy: string;
  setSortBy: (sortBy: string) => void;
  sortDropdownOpen: boolean;
  setSortDropdownOpen: (sortDropdownOpen: boolean) => void;
}

export const SORT_ITEMS = [
  { label: "Date (Newest First)", value: "date_desc" },
  { label: "Date (Oldest First)", value: "date_asc" },
  { label: "Name (A-Z)", value: "name_asc" },
  { label: "Name (Z-A)", value: "name_desc" },
];

const useSortingDropdown = ({ defaultSortBy = "name_asc" }: UseSortingDropdownParams): UseSortingDropdownReturn => {
  const [sortBy, setSortBy] = useState<string>(defaultSortBy);
  const [sortDropdownOpen, setSortDropdownOpen] = useState(false);

  return {
    sortBy,
    setSortBy,
    sortDropdownOpen,
    setSortDropdownOpen,
  };
};

export default useSortingDropdown;
